import { render } from "./ManageRiskItemModal.vue?vue&type=template&id=3b20ecf9"
import script from "./ManageRiskItemModal.js?vue&type=script&lang=js"
export * from "./ManageRiskItemModal.js?vue&type=script&lang=js"

import "./ManageRiskItemModal.vue?vue&type=style&index=0&id=3b20ecf9&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__